export default {
  quickLinks: '快速連結',
  support: '支援',
  privacyPolicy: '隱私權政策',
  termsOfService: '服務條款',
  footerDescription: '您的寵物照護數位助手，讓愛更有溫度，讓照顧更輕鬆。',
  craftedWith: '用愛為寵物打造',
  allRightsReserved: '版權所有',
  availableLanguages: '支援語言',
  multiLanguageSupport: '多語言支援'
};